import { HttpErrorResponse } from '@angular/common/http';

/**
 * 401 or 403 that ended the picker session (401: refresh + retry failed; 403: cc-rt-core denied the access).
 * `errorInterceptor` already logged out and redirects to `/auth`. Extends the original `HttpErrorResponse`, so code
 * reading `status` keeps working; screens use `isSessionExpiredError` to skip their own error modal.
 */
export class SessionExpiredError extends HttpErrorResponse {
  constructor(original: HttpErrorResponse) {
    super({
      error: original.error,
      headers: original.headers,
      status: original.status,
      statusText: original.statusText,
      url: original.url ?? undefined,
    });
  }
}

export function isSessionExpiredError(err: unknown): err is SessionExpiredError {
  return err instanceof SessionExpiredError;
}
